/** Create an element with attributes and children. `class` maps to className. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: (Node | string)[] = []
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (key === 'class') node.className = value;
    else node.setAttribute(key, value);
  }
  for (const child of children) node.append(child);
  return node;
}

/** Force a synchronous style/layout flush so the next class change animates from a painted state. */
export function reflow(node: HTMLElement): void {
  void node.offsetWidth;
}
